export default __webpack_public_path__ + "static/Intro_Imagery_What_Makes_Us_ToyotaNZ_Placeholder-84e703493eb0fc1510132a2e49df38ab.jpeg";